module.exports = __webpack_public_path__ + "img/task-context-menu.95b7df04.png";